import { useEffect, useState } from 'react'
import { useAuth } from '@structural-climbing/auth'

export interface RouteSetterOption {
  id: string
  name: string
}

/**
 * The people a route can be credited to: the gym's owner and staff. Loaded only
 * while `enabled`, so a closed edit form costs nothing.
 *
 * A failed load leaves the list empty rather than raising an error. The form
 * then hides the setter field and everything else on it still saves.
 */
export function useRouteSetters(apiUrl: string, enabled: boolean): RouteSetterOption[] {
  const { getAccessTokenSilently } = useAuth()
  const [setters, setSetters] = useState<RouteSetterOption[]>([])

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    void (async () => {
      try {
        const token = await getAccessTokenSilently()
        const res = await fetch(`${apiUrl}/climbing-routes/setters`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        if (!res.ok) return
        const data: unknown = await res.json()
        if (!cancelled && Array.isArray(data)) setSetters(data as RouteSetterOption[])
      } catch {
        // Leave the list as it is; see above.
      }
    })()
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl, enabled])

  return setters
}
